import { Component, computed, inject, input } from '@angular/core';
import { AufgabeTypStaticTaetigkeitLabel } from '@schir-int-client/aufgabe-shared';
import { CreateAufgabeFormService } from '../../create-aufgabe-dialog/create-aufgabe.formservice';

type AllowedAufgabenTyp = keyof typeof AufgabeTypStaticTaetigkeitLabel;

@Component({
	selector: 'schir-int-client-aufgabe-with-static-taetigkeit-editor',
	templateUrl: './aufgabe-with-static-taetigkeit-editor.component.html',
	standalone: false,
})
export class AufgabeWithStaticTaetigkeitEditorComponent {
	private readonly formService = inject(CreateAufgabeFormService);

	public readonly aufgabenTyp = input.required<AllowedAufgabenTyp>();
	public readonly staticTaetigkeitLabel = computed(() => AufgabeTypStaticTaetigkeitLabel[this.aufgabenTyp()]);

	get formGroup() {
		return this.formService.form.controls[this.aufgabenTyp()];
	}
}
